import * as config from "../config";
import {Align} from "../class/align";
import _ from 'underscore';
import uuid from 'uuid/v1'

export default class Manager {
    constructor(scene, group) {
        this.scene = scene;
        this.groupManager = group;
        this.dbManager = {
            lastCreated: null,
            items: []
        };
        // this.makeAnimations();
    }

    generateManager() {
        let date = new Date();
        if (!this.dbManager.lastCreated || date >= this.dbManager.lastCreated) {
            let id = uuid();
            this.dbManager.lastCreated = date.setMinutes(date.getMinutes() + 1);
            let x = [100, config.width - 100];
            let manager = this.scene.physics.add.sprite(
                x[Phaser.Math.Between(0, 1)],
                this.scene.background.y + this.scene.background.displayHeight / 2 - 135,
                'game_manager'
            );
            manager.body.setSize(manager.width, manager.height, true);
            Align.scaleToGameW(manager, .07);
            this.groupManager.add(manager);
            manager.setGravityY(500);
            manager.body.setAllowDrag(false);
            manager.id = id;
            manager.body.collideWorldBounds = false;
            manager.isHitted = false;
            this.dbManager.items.push({
                id,
                lastMove: null,
                hp: config.manager.hp,
                item: manager
            })
        }
        this.randomMove();
    }

    randomMove() {
        let date = new Date();
        _.each(this.groupManager.getChildren(), (manager) => {
            if (manager.body.velocity.x > 0 && manager.x >= config.width - manager.displayWidth / 2 && !manager.isHitted
                || manager.body.velocity.x < 0 && manager.x <= manager.displayWidth / 2 && !manager.isHitted) {
                manager.body.velocity.x = manager.body.velocity.x * -1
                manager.flipX = !manager.flipX
            }
            // if (manager.flipX === false) {
            //     manager.body.setOffset(105, 100);
            // } else {
            //     manager.body.setOffset(122.5, 100);
            // }

            if (manager.body.velocity.x > 0) {
                manager.flipX = false
            } else {
                manager.flipX = true;
            }

            let index = _.findIndex(this.dbManager.items, element => {
                return element.id === manager.id
            });
            // if (!this.dbManager.items[index].lastMove || date >= this.dbManager.items[index].lastMove) {
            //     this.dbManager.items[index].lastMove = date.setSeconds(date.getSeconds() + 5);
            //     let stop = Phaser.Math.Between(0, 3);
            //     if (stop !== 2 && !this.dbManager.items[index].item.isHitted) {
            //         let velocity = Phaser.Math.Between(-200, 200);
            //         manager.setVelocityX(velocity);
            //     } else {
            //         manager.setVelocityX(0);
            //     }
            // }
        })
    }
}
